module.exports = __webpack_public_path__ + "img/droven-ribs.86209bec.png";